( function ( _s ) {
	_s.fn.tabbedContent = function () {
		return this.el.forEach( el => {
			const _self = _s( el );
			const _links = _self.find( '.nav-link' );

			const setHash = hash => {
				window.location.hash = hash;
			};

			const initTabs = () => {
				const hash = window.location.hash;
				const link = document.querySelector( `[data-bs-target="${ hash }"]` );

				_links.attr( 'tabindex', '0' );

				if ( hash && link ) {
					link.click();
					document.querySelector( hash ).scrollIntoView();
				}
			};

			_links.on( 'shown.bs.tab', e => {
				setHash( _s( e.target ).attr( 'data-bs-target' ) );
				_links.attr( 'tabindex', '0' );
				e.target.focus();
			} );

			initTabs();
		} );
	};

	_s( document ).ready( () => {
		_s( '.module.tabbed-content-module-container' ).tabbedContent();
	} );
} )( window._s );
